import { useMemo } from 'react';
import useAuthStore from '../stores/authStore';
import { UseAuthReturn } from '../types/auth';

// Hook principal para acessar autenticação
export const useAuth = (): UseAuthReturn => {
  const authStore = useAuthStore();
  
  return useMemo(() => ({
    ...authStore,
    isLoggedIn: authStore.isAuthenticated,
  }), [authStore]);
};

// Hook para verificar se usuário está logado (apenas boolean)
export const useIsAuthenticated = (): boolean => {
  return useAuthStore(state => state.isAuthenticated);
};

// Hook para obter dados do usuário
export const useUser = () => {
  return useAuthStore(state => state.user);
};

// Hook para obter loading state
export const useAuthLoading = (): boolean => {
  return useAuthStore(state => state.isLoading);
};

// Hook que força autenticação (redirect se não logado)
export const useRequireAuth = () => {
  const { isAuthenticated, isInitialized } = useAuthStore();
  
  // Pode ser usado em pages que exigem autenticação
  // O ProtectedRoute já cuida do redirect, mas este hook
  // pode ser útil para lógica condicional em componentes
  
  return {
    isAuthenticated,
    isInitialized,
    isReady: isInitialized && isAuthenticated,
  };
};

// Hook para ações de auth sem estado
export const useAuthActions = () => {
  return useAuthStore(state => ({
    login: state.login,
    logout: state.logout,
    updateProfile: state.updateProfile,
    changePassword: state.changePassword,
    refreshAuth: state.refreshAuth,
    checkAuth: state.checkAuth,
  }));
};

// Hook para informações do usuário
export const useUserInfo = () => {
  return useAuthStore(state => ({
    user: state.user,
    displayName: state.getDisplayName(),
    initials: state.getInitials(),
    isAdmin: state.isAdmin(),
  }));
};

export default useAuth;